// src/auth/permissions.js
export const ROLES = {
  HEAD_ADMIN: "head_admin",
  ASSOC_ADMIN_1: "associate_admin_1",
  SECRETARY: "secretary",
  ASSOC_SECRETARY: "associate_secretary",
  TREASURER: "treasurer",
  ASSOC_TREASURER: "associate_treasurer",
  PRAYER_LEAD: "prayer_lead",
  ASSOC_PRAYER_LEAD: "associate_prayer_lead",
  SUNDAY_SCHOOL_LEAD: "sunday_school_lead",
  SUNDAY_SCHOOL_ASSOC: "sunday_school_associate",
  PASTORAL_TEAM_1: "pastoral_team_1",
  PASTORAL_TEAM_2: "pastoral_team_2",
  MEDIA_HEAD: "media_head",
  MEDIA_HEAD_ASSOC: "media_head_associate"
};

export const ADMIN_ROLES = [ROLES.HEAD_ADMIN, ROLES.ASSOC_ADMIN_1];
export const PASTORAL_ROLES = [ROLES.PASTORAL_TEAM_1, ROLES.PASTORAL_TEAM_2];
export const SECRETARY_ROLES = [ROLES.SECRETARY, ROLES.ASSOC_SECRETARY];
export const MEDIA_ROLES = [ROLES.MEDIA_HEAD, ROLES.MEDIA_HEAD_ASSOC, ROLES.SUNDAY_SCHOOL_LEAD, ROLES.SUNDAY_SCHOOL_ASSOC];
export const TREASURY_ROLES = [ROLES.TREASURER, ROLES.ASSOC_TREASURER];

export function isRoleAllowed(currentRole, allowedRoles) {
  if (!allowedRoles || allowedRoles.length === 0) return true;
  if (!currentRole) return false;
  return allowedRoles.includes(currentRole);
}

// Normalize raw role values from API/localStorage to our canonical snake_case ROLES
export function normalizeRole(rawRole) {
  const v = (rawRole || "").toString().trim().toLowerCase();
  switch (v) {
    case "head_admin":
      return ROLES.HEAD_ADMIN;
    case "associate_admin_1":
      return ROLES.ASSOC_ADMIN_1;
    case "secretary":
      return ROLES.SECRETARY;
    case "associate_secretary":
      return ROLES.ASSOC_SECRETARY;
    case "treasurer":
      return ROLES.TREASURER;
    case "associate_treasurer":
      return ROLES.ASSOC_TREASURER;
    case "prayer_lead":
      return ROLES.PRAYER_LEAD;
    case "associate_prayer_lead":
      return ROLES.ASSOC_PRAYER_LEAD;
    case "sunday_school_lead":
      return ROLES.SUNDAY_SCHOOL_LEAD;
    case "sunday_school_associate":
    case "sunday_school_assoc":
      return ROLES.SUNDAY_SCHOOL_ASSOC;
    case "pastoral_team_1":
      return ROLES.PASTORAL_TEAM_1;
    case "pastoral_team_2":
      return ROLES.PASTORAL_TEAM_2;
    case "media_head":
      return ROLES.MEDIA_HEAD;
    case "media_head_associate":
      return ROLES.MEDIA_HEAD_ASSOC;
    default:
      return v || null;
  }
}

export function getStoredRoleNormalized() {
  const raw = localStorage.getItem("role");
  return normalizeRole(raw);
}
export const ROUTE_ACCESS = {
  "/home": [],
  "/enabledRoles": [...ADMIN_ROLES],
  "/userManagement": [...ADMIN_ROLES],
  "/memberManagement": [...ADMIN_ROLES, ...SECRETARY_ROLES, ...PASTORAL_ROLES],
  "/leaderManagement": [...ADMIN_ROLES, ...PASTORAL_ROLES],
  "/calendar": [...ADMIN_ROLES, ...SECRETARY_ROLES, ...PASTORAL_ROLES],
  "/eventRequests": [...ADMIN_ROLES, ...SECRETARY_ROLES, ...PASTORAL_ROLES],
  "/announcements": [...ADMIN_ROLES, ...SECRETARY_ROLES, ...PASTORAL_ROLES, ROLES.SUNDAY_SCHOOL_LEAD, ROLES.SUNDAY_SCHOOL_ASSOC],
  "/prayers": [...ADMIN_ROLES, ...PASTORAL_ROLES, ROLES.PRAYER_LEAD, ROLES.ASSOC_PRAYER_LEAD],
  "/testimonies": [],

  "/contentManagement": [...ADMIN_ROLES, ...MEDIA_ROLES, ...PASTORAL_ROLES],
  "/contentManagement/audio": [...ADMIN_ROLES, ...MEDIA_ROLES, ...PASTORAL_ROLES],
  "/contentManagement/bibleVersion": [],
  "/contentManagement/devotion": [...ADMIN_ROLES, ...MEDIA_ROLES, ...PASTORAL_ROLES],
  "/contentManagement/document": [...ADMIN_ROLES, ...MEDIA_ROLES, ...PASTORAL_ROLES],
  "/contentManagement/podcast": [...ADMIN_ROLES, ...MEDIA_ROLES, ...PASTORAL_ROLES],
  "/contentManagement/quote": [...ADMIN_ROLES, ...MEDIA_ROLES, ...PASTORAL_ROLES],
  "/contentManagement/streaming": [...ADMIN_ROLES, ...MEDIA_ROLES, ...PASTORAL_ROLES],
  "/contentManagement/verses": [...ADMIN_ROLES, ...MEDIA_ROLES, ...PASTORAL_ROLES],

  "/volunteering": [],
  "/donations": [ROLES.TREASURER, ROLES.ASSOC_TREASURER, ROLES.HEAD_ADMIN],
  "/reports": [ROLES.TREASURER, ROLES.ASSOC_TREASURER, ROLES.HEAD_ADMIN],
  "/settings": []
};
